<template>
    <div class="page">
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="100px" :inline="true" size="small"
                 class="query-form" @submit.native.prevent>
            <el-form-item label="门店名称">
                <el-input style='width: 200px;' v-model="queryForm.storeName"></el-input>
            </el-form-item>
            <el-form-item label="所属账号" prop="userId">
                <GridSelectU style="width: 200px;" title="选择所属账号" labelName="userName"
                             labelValue="id" :value="queryForm.userId" :limit='1' size='small'
                             placeholder='请选择所属账号'
                             @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search"
                             dataListUrl="/mpp/user/findList" entityBeanName="mppUser"
                             queryEntityUrl="/mpp/user/get">
                </GridSelectU>
            </el-form-item>
            <el-form-item
                label="门店审核状态"
                prop="status"
            >
                <el-select
                    v-model="queryForm.status"
                    size="small"
                    placeholder="请选择门店审核状态"
                    clearable
                    style="width: 200px"
                >
                    <el-option :label="item.value" :value="item.key" v-for="(item,index) in auditStatus" :key="index"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getShopStoreList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button type="primary" size="small" icon="el-icon-plus" @click="addShopStore">新建</el-button>
                    <el-button type="warning" plain size="small" icon="el-icon-edit"
                               :disabled="multipleSelection.length != 1"
                               @click="editShopStore(null)">修改
                    </el-button>
                    <el-button type="danger" plain size="small" icon="el-icon-delete"
                               :disabled="multipleSelection.length <= 0"
                               @click="deleteShopStore(null)">删除
                    </el-button>
                </div>

                <div class="icon-group">
                    <el-upload v-if="this.isImportDate" class="upload-demo" action="#" :http-request="upload"
                               :show-file-list="true">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span title="搜索" class="icon-box" @click="search">
                    <Icon color="#606266">
                      <Search />
                    </Icon>
                  </span>
                    <span title="下载模板" class="icon-box" @click="importTemplate">
                    <Icon color="#606266">
                      <ArrowDown />
                    </Icon>
                  </span>
                    <span class="icon-box" title="导入数据" @click="isImport">
                    <Icon color="#606266">
                      <ArrowExportUp24Regular />
                    </Icon>
                  </span>
                    <span title="导出数据" class="icon-box" @click="exportShopStoreList">
                    <Icon color="#606266">
                      <ArrowDownload24Regular />
                    </Icon>
                  </span>
                    <span class="icon-box" @click="refreshShopStoreList">
                    <Icon color="#606266">
                      <Refresh />
                    </Icon>
                  </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table :data="shopStoreList" row-key="id" border height="100%" :header-row-style="{ height: '10px' }"
                      :header-cell-style="{ padding: '10px' }" :row-style="{ height: '9px' }"
                      :cell-style="{ padding: '9px' }"
                      @selection-change="handleSelectionChange" size="small">
                <el-table-column align="center" type="selection" width="60"></el-table-column>
                <el-table-column align="center" prop="storeLogo" label="门店信息" min-width="260"
                                 :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div v-if='scope.row.storeLogo'
                             style="display: flex;justify-content: center;align-items: center;">
                            <el-image @click='updateSrcList(scope.row.storeLogo)' style="width: 60px; height: 60px"
                                      :src="scope.row.storeLogo" :preview-src-list="srcList"></el-image>
                            <div style="flex:auto;text-align: center;margin-left: 4px;">
                                <div>{{ scope.row.storeName }}</div>
                                <div :style="{'fontSize':'12px',color:scope.row.openStatus == 1 ? 'green':'red'}">
                                    ({{ scope.row.openStatus == 1 ? '正常营业' : '暂停营业' }})
                                </div>
                                <div>{{ scope.row.openHours }}</div>
                                <!--                                <div>收益比列：{{ scope.row.incomeRatio }}</div>-->
                            </div>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="userId" label="用户信息" width="180">
                    <template slot-scope="scope" v-if='scope.row.user'>
                        <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                        <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                        <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                    </template>
                    <template slot-scope="scope" v-else>
                        <div>暂无关联用户</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="contactPerson" label="联系人"
                                 width="180">
                    <template slot-scope="scope">
                        <div v-if="scope.row.contactPerson">
                            <div style="text-align: left">联系姓名:{{ scope.row.contactPerson }}</div>
                            <div style="text-align: left">联系电话:{{ scope.row.contactPhone }}</div>
                            <div style="text-align: left">地址:{{ scope.row.storeAddress }}</div>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='status'
                    label='门店审核状态'
                    width='150'
                >
                    <template slot-scope="scope">
                        <div class="flex" :class="{'active': scope.row.status == 2}">
                            <span style="font-size: 25px;margin-top: -5px">●</span>
                            <span>{{ computeAuditStatus(scope.row.status) }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='storeType'
                    label='进件审核状态'
                    width='240'
                >
                    <template slot-scope="scope">
                        <div style="display: flex;align-items: center">
                            <div>银盛支付审核状态：</div>
                            <div class="flex" v-if="scope.row.orginfo" :class="{'active': scope.row.orginfo.thirdStatus == 7}">
                                <span style="font-size: 25px;margin-top: -5px">●</span>
                                <span>{{ returnV3Status(scope.row.orginfo.thirdStatus) }}</span>
                            </div>
                            <div v-else>-</div>
                        </div>
                        <div style="display: flex;align-items: center">
                            <div>微信支付认证状态：</div>
                            <div class="flex" v-if="scope.row.orginfo" :class="{'active': scope.row.orginfo.wxpayStatus}">
                                <span style="font-size: 25px;margin-top: -5px">●</span>
                                <span v-if="scope.row.orginfo.wxpayStatus">已认证</span>
                                <span v-else>未认证</span>
                            </div>
                            <div v-else>-</div>
                        </div>
                        <div style="display: flex;align-items: center">
                            <div>支付宝支付认证状态：</div>
                            <div class="flex" v-if="scope.row.orginfo" :class="{'active': scope.row.orginfo.alipayStatus}">
                                <span style="font-size: 25px;margin-top: -5px">●</span>
                                <span v-if="scope.row.orginfo.alipayStatus">已认证</span>
                                <span v-else>未认证</span>
                            </div>
                            <div v-else>-</div>
                        </div>
                    </template>
                </el-table-column>
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip='true'-->
<!--                    align='center'-->
<!--                    label='支付审核状态'-->
<!--                    width='150'-->
<!--                >-->
<!--                    <template slot-scope="scope">-->
<!--                        <div class="flex" v-if="scope.row.orginfo" :class="{'active': scope.row.orginfo.thirdStatus == 2}">-->
<!--                            <span style="font-size: 25px;margin-top: -5px">●</span>-->
<!--                            <span>{{ computeAuditStatus(scope.row.orginfo.thirdStatus) }}</span>-->
<!--                        </div>-->
<!--                        <div v-else>-</div>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip='true'-->
<!--                    align='center'-->
<!--                    label='微信支付认证状态'-->
<!--                    width='150'-->
<!--                >-->
<!--                    <template slot-scope="scope">-->
<!--                        <div class="flex" v-if="scope.row.orginfo" :class="{'active': scope.row.orginfo.wxpayStatus}">-->
<!--                            <span style="font-size: 25px;margin-top: -5px">●</span>-->
<!--                            <span v-if="scope.row.orginfo.wxpayStatus">已认证</span>-->
<!--                            <span v-else>未认证</span>-->
<!--                        </div>-->
<!--                        <div v-else>-</div>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                    :show-overflow-tooltip='true'-->
<!--                    align='center'-->
<!--                    label='支付宝支付认证状态'-->
<!--                    width='150'-->
<!--                >-->
<!--                    <template slot-scope="scope">-->
<!--                        <div class="flex" v-if="scope.row.orginfo" :class="{'active': scope.row.orginfo.alipayStatus}">-->
<!--                            <span style="font-size: 25px;margin-top: -5px">●</span>-->
<!--                            <span v-if="scope.row.orginfo.alipayStatus">已认证</span>-->
<!--                            <span v-else>未认证</span>-->
<!--                        </div>-->
<!--                        <div v-else>-</div>-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column :show-overflow-tooltip="true" align="center" label="返回报文" width="170">
                    <template slot-scope="scope">
                        <div class="flex" v-if="scope.row.orginfo">
                            <span>{{scope.row.orginfo.resultMsg}}</span>
                        </div>
                        <div v-else>-</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" label="审核失败原因" width="170">
                    <template slot-scope="scope">
                        <div class="flex" v-if="scope.row.status == 3">
                            <span>{{scope.row.refuseReason}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="storeLogo" label="门头照" min-width="160"
                                 :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div v-if='scope.row.storeBanner'
                             style="display: flex;justify-content: center;align-items: center;">
                            <el-image @click='updateSrcList(scope.row.storeBanner)' style="width: 60px; height: 60px"
                                      :src="scope.row.storeBanner" :preview-src-list="srcList"></el-image>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="storeInterior1" label="收银台图和店内景图" min-width="220"
                                 :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div style="display:flex;align-items: center;justify-content: center">
                            <div v-if='scope.row.storeInterior1'
                                 style="display: flex;justify-content: center;align-items: center;">
                                <el-image @click='updateSrcList(scope.row.storeInterior1)' style="width: 60px; height: 60px"
                                          :src="scope.row.storeInterior1" :preview-src-list="srcList"></el-image>
                            </div>
                            <div v-else>--</div>
                            <div v-if='scope.row.storeInterior2'
                                 style="display: flex;justify-content: center;align-items: center;margin-left: 20px">
                                <el-image @click='updateSrcList(scope.row.storeInterior2)' style="width: 60px; height: 60px"
                                          :src="scope.row.storeInterior2" :preview-src-list="srcList"></el-image>
                            </div>
                            <div v-else>--</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="createTime" label="创建时间" width="170">
                </el-table-column>
                <el-table-column fixed="right" align="center" label="操作" width="350">
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click='ShopStoreAudit(scop.row)' v-if='scop.row.status == 1'>
                                <el-button type='primary' size='mini'>审核</el-button>
                            </div>
                            <div @click="checkShopStore(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editShopStore(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
<!--                            <div @click="showRegister(scop.row.orginfo,scop.row.id)">-->
<!--                                <Icon size="16">-->
<!--                                    <Edit24Regular />-->
<!--                                </Icon>-->
<!--                                <span class="operation-label">进件</span>-->
<!--                            </div>-->
                            <div @click="deleteShopStore(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                        <div class="operation">
                            <div @click="openList(scop.row.id)">
                                <i class="el-icon-folder-opened" size="16"></i>
                                <span class="operation-label">带货商品</span>
                            </div>
                            <div @click="openSteam(scop.row.id)">
                                <i class="el-icon-folder-opened" size="16"></i>
                                <span class="operation-label">管理团购</span>
                            </div>
                            <div @click="addBanner(scop.row.id)">
                                <i class="el-icon-circle-plus-outline" size="16"></i>
                                <span class="operation-label">管理相册</span>
                            </div>
                            <div @click="addLB(scop.row.id)">
                                <i class="el-icon-circle-plus-outline" size="16"></i>
                                <span class="operation-label">云喇叭设置</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination @size-change="sizeChange" @current-change="currentChange"
                               :current-page.sync="currentPage"
                               :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="totalNum" background :pager-count="7">
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog :title="shopStoreStates[shopStoreState]" :visible.sync="showDialog" width="60%"
                       @close="closeDialog">
                <div>
                    <el-form :model="shopStore" ref="shopStoreForm" :rules="rules" label-width="140px" :inline="true"
                             size="small">
                        <el-form-item label="门店名称" prop="storeName">
                            <el-input style='width: 200px;' size="small" v-model="shopStore.storeName"
                                      :disabled="shopStoreState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="门店分类" prop="typeId">
                            <el-select
                                placeholder='请选择门店分类'
                                clearable
                                style='width: 200px'
                                size='small'
                                v-model='shopStore.typeId'
                                :disabled="shopStoreState == 'check'"
                            >
                                <el-option
                                    v-for='(item,index) in typeIdArry'
                                    :key='index'
                                    :label='item.typeName'
                                    :value='item.id'
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='所属行业'
                            prop='industryId'
                        >
                            <el-select
                                clearable
                                style="width: 200px"
                                v-model="shopStore.industryId"
                                :disabled="shopStoreState == 'check'"
                                placeholder="请选择"
                                size="small"
                            >
                                <el-tree
                                    :data="industryList"
                                    :props="treeProps"
                                    :render-after-expand="false"
                                >
                                    <div
                                        class="custom-tree-node flex items-center"
                                        slot-scope="{ node, data }"
                                    >
                                        <el-option
                                            :label="node.label"
                                            :value="data.id"
                                        > </el-option>
                                    </div>
                                </el-tree>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="门店等级" prop="grade">
                            <el-select
                                placeholder='请选择门店等级'
                                clearable
                                style='width: 200px'
                                size='small'
                                v-model='shopStore.grade'
                                :disabled="shopStoreState == 'check'"
                            >
                                <el-option
                                    v-for='(item,index) in gradeList'
                                    :key='index'
                                    :label='item.value'
                                    :value='item.key'
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="服务费类型" prop="serviceType">
                            <el-select
                                placeholder='请选择服务费类型'
                                clearable
                                style='width: 200px'
                                size='small'
                                v-model='shopStore.serviceType'
                                :disabled="shopStoreState == 'check'"
                            >
                                <el-option
                                    v-for='(item,index) in serviveTypeList'
                                    :key='index'
                                    :label='item.value'
                                    :value='item.key'
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="服务费比例" prop="serviceRatio" v-if="shopStore.serviceType">
                            <el-input style='width: 200px;' size="small" v-model="shopStore.serviceRatio" :disabled="shopStoreState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="签约服务费类型" prop="signServiceType">
                            <el-select
                                placeholder='请选择签约服务费类型'
                                clearable
                                style='width: 200px'
                                size='small'
                                v-model='shopStore.signServiceType'
                                :disabled="shopStoreState == 'check'"
                            >
                                <el-option
                                    v-for='(item,index) in serviveTypeList'
                                    :key='index'
                                    :label='item.value'
                                    :value='item.key'
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
<!--                        <el-form-item label="收益比例" prop="incomeRatio">-->
<!--                            <el-input style='width: 200px;' size="small" v-model="shopStore.incomeRatio"-->
<!--                                      :disabled="shopStoreState == 'check'"></el-input>-->
<!--                        </el-form-item>-->
                        <el-form-item label="门店位置" prop="storeAddress">
                            <location
                                style='width: 200px;'
                                :areaTreeDate="provinceIdList"
                                :longitude="shopStore.storePosition.split(',')[0]"
                                :latitude="shopStore.storePosition.split(',')[1]"
                                :provinceId="shopStore.provinceId"
                                :cityId="shopStore.cityId"
                                :areaId="shopStore.areaId"
                                :streetId="shopStore.streetId"
                                :address="shopStore.storeAddress"
                                :disabled="shopStoreState == 'check'"
                                @getLocation="getLocation"
                            ></location>
                        </el-form-item>
                        <el-form-item label="所属省份" prop="provinceId">
                            <el-select
                                style='width:200px'
                                v-model='shopStore.provinceId'
                                size='small'
                                placeholder='请选择省份'
                                :disabled="shopStoreState == 'check'"
                            >
                                <el-option
                                    v-for='item in provinceIdList'
                                    :key='item.id'
                                    :label='item.name'
                                    :value='item.id'
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="所属城市" prop="cityId">
                            <el-select
                                style='width:200px'
                                v-model='shopStore.cityId'
                                size='small'
                                placeholder='请选择城市'
                                :disabled="shopStoreState == 'check'"
                            >
                                <el-option
                                    v-for='item in cityIdList3'
                                    :key='item.id'
                                    :label='item.name'
                                    :value='item.id'
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="所属区县" prop="areaId">
                            <el-select
                                style='width:200px'
                                v-model='shopStore.areaId'
                                size='small'
                                placeholder='请选择区县'
                                :disabled="shopStoreState == 'check'"
                            >
                                <el-option
                                    v-for='item in areaIdList3'
                                    :key='item.id'
                                    :label='item.name'
                                    :value='item.id'
                                ></el-option>
                            </el-select>
                        </el-form-item>
                         <el-form-item
                            label="所属乡镇"
                            prop="streetId"
                            v-if="shopStore.provinceId != 1 && shopStore.provinceId != 2 && shopStore.provinceId != 3 && shopStore.provinceId != 4"
                        >
                            <el-select
                                style='width:200px'
                                v-model='shopStore.streetId'
                                size='small'
                                placeholder='请选择乡镇'
                                :disabled="shopStoreState == 'check'"
                            >
                                <el-option
                                    v-for='item in streetIdList3'
                                    :key='item.id'
                                    :label='item.name'
                                    :value='item.id'
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="门店定位" prop="storePosition">
                            <el-input style='width: 200px;' size="small" v-model="shopStore.storePosition"
                                      :disabled="shopStoreState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="门店标签" prop="storeTags">
                            <el-input size="small" style="width: 200px" v-model="shopStore.storeTags" @focus="openTabs"
                                      :disabled="shopStoreState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="营业状态" prop="openStatus">
                            <el-select placeholder="请选择状态" :disabled="shopStoreState == 'check'" clearable
                                       style="width: 200px"
                                       size="small" v-model="shopStore.openStatus">
                                <el-option v-for='(item, index) in productStatusEnumList' :key='index'
                                           :label="item.value"
                                           :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="审核状态" prop="openStatus">
                            <el-select placeholder="请选择审核状态" :disabled="shopStoreState == 'check'" clearable
                                       style="width: 200px"
                                       size="small" v-model="shopStore.status">
                                <el-option v-for='(item, index) in auditStatus' :key='index'
                                           :label="item.value"
                                           :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="营业时间" prop="openHours">
                            <el-time-picker
                                :disabled="shopStoreState == 'check'"
                                is-range
                                style="width: 200px;"
                                v-model="shopStore.openHours"
                                range-separator="至"
                                format='HH:mm'
                                value-format='HH:mm'
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                                placeholder="选择时间范围">
                            </el-time-picker>
                        </el-form-item>
                        <el-form-item label="联系姓名" prop="contactPerson">
                            <el-input style='width: 200px;' size="small" v-model="shopStore.contactPerson"
                                      :disabled="shopStoreState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话" prop="contactPhone">
                            <el-input style='width: 200px;' size="small" v-model="shopStore.contactPhone"
                                      :disabled="shopStoreState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="是否展示" prop="isShow">
                            <el-select placeholder="请选择是否展示" :disabled="shopStoreState == 'check'" clearable
                                       style="width: 200px"
                                       size="small" v-model="shopStore.isShow">
                                <el-option label="展示" :value="1">
                                </el-option>
                                <el-option label="隐藏" :value="0">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="门店备注" prop="remarks">
                            <el-input style='width: 200px;' size="small" v-model="shopStore.remarks"
                                      :disabled="shopStoreState == 'check'"></el-input>
                        </el-form-item>
                        <el-form-item label="门店管理" prop="userId">
                            <GridSelectU style="width: 200px;" title="选择管理员" labelName="userName"
                                         :disabled="shopStoreState == 'check'"
                                         labelValue="id" :value="shopStore.userId" :limit='1' size='small'
                                         placeholder='请选择用户'
                                         @getValue="getValueUser" :columns="USER_code" :searchs="USER_search"
                                         dataListUrl="/mpp/user/findList" entityBeanName="mppUser"
                                         queryEntityUrl="/mpp/user/get">
                            </GridSelectU>
                        </el-form-item>
                        <el-form-item label="门店推广" prop="promoterId">
                            <GridSelectLi
                                :disabled="shopStoreState == 'check'"
                                style="width: 200px"
                                title="选择推广人"
                                labelName="promoterName"
                                labelValue="id"
                                :did="did"
                                :value="shopStore.promoterId"
                                :limit="1"
                                size="small"
                                placeholder="请选择商品"
                                @getValue="getSeachValuebrandId"
                                :columns="PROMOTER_code"
                                :searchs="PROMOTER_search"
                                dataListUrl="/mpp/promoter/findList"
                                entityBeanName="mppPromoter"
                                queryEntityUrl="/mpp/promoter/get"
                            >
                            </GridSelectLi>
                        </el-form-item>
<!--                        <el-form-item label="门店配送" prop="deliverId">-->
<!--                            <GridSelectLi-->
<!--                                :disabled="shopStoreState == 'check'"-->
<!--                                style="width: 200px"-->
<!--                                title="选择配送员"-->
<!--                                labelName="personName"-->
<!--                                labelValue="id"-->
<!--                                :did="did"-->
<!--                                :value="shopStore.deliverId"-->
<!--                                :limit="1"-->
<!--                                size="small"-->
<!--                                placeholder="请选择配送人"-->
<!--                                @getValue="getSeachValuepersonId"-->
<!--                                :columns="PERSON_code"-->
<!--                                :searchs="PERSON_search"-->
<!--                                dataListUrl="/shop/deliver/findList"-->
<!--                                entityBeanName="shopDeliver"-->
<!--                                queryEntityUrl="/shop/deliver/get"-->
<!--                            >-->
<!--                            </GridSelectLi>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item label="门店分拣" prop="sortingId">-->
<!--                            <GridSelectLi-->
<!--                                :disabled="shopStoreState == 'check'"-->
<!--                                style="width: 200px"-->
<!--                                title="选择分拣员"-->
<!--                                labelName="personName"-->
<!--                                labelValue="id"-->
<!--                                :did="did"-->
<!--                                :value="shopStore.sortingId"-->
<!--                                :limit="1"-->
<!--                                size="small"-->
<!--                                placeholder="请选择分拣人"-->
<!--                                @getValue="getSeachValuepersonId1"-->
<!--                                :columns="SORTING_code"-->
<!--                                :searchs="SoRTING_search"-->
<!--                                dataListUrl="/shop/sorting/findList"-->
<!--                                entityBeanName="shopSorting"-->
<!--                                queryEntityUrl="/shop/sorting/get"-->
<!--                            >-->
<!--                            </GridSelectLi>-->
<!--                        </el-form-item>-->
                        <el-form-item label="门店Logo" prop="storeLogo">
                            <div style="display: flex;width: 200px;">
                                <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                           :disabled="shopStoreState == 'check'" class="avatar-uploader"
                                           :show-file-list="false"
                                           :http-request="uploadImage">
                                    <img v-if="shopStore.storeLogo" :src="shopStore.storeLogo" class="avatar"
                                         size="small" />
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStore.storeLogo)">查看</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item label="门头照片" prop="storeInterior">
                            <div style="display: flex;width: 200px;">
                                <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                           :disabled="shopStoreState == 'check'" class="avatar-uploader"
                                           :show-file-list="false"
                                           :http-request="uploadImage1">
                                    <img v-if="shopStore.storeBanner" :src="shopStore.storeBanner" class="avatar"
                                         size="small" />
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStore.storeBanner)">查看</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item label="收银台图" prop="storeInterior1">
                            <div style="display: flex;width: 200px;">
                                <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                           :disabled="shopStoreState == 'check'" class="avatar-uploader"
                                           :show-file-list="false"
                                           :http-request="uploadImage51">
                                    <img v-if="shopStore.storeInterior1" :src="shopStore.storeInterior1" class="avatar"
                                         size="small" />
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStore.storeInterior1)">查看</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item label="内景照片" prop="storeInterior2">
                            <div style="display: flex;width: 200px;">
                                <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                           :disabled="shopStoreState == 'check'" class="avatar-uploader"
                                           :show-file-list="false"
                                           :http-request="uploadImage52">
                                    <img v-if="shopStore.storeInterior2" :src="shopStore.storeInterior2" class="avatar"
                                         size="small" />
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                                <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStore.storeInterior2)">查看</el-button>
                            </div>
                        </el-form-item>
                        <el-image ref="images" v-show="false" @click='updateSrcList(imageSrc)' style="width: 60px; height: 60px"
                                  :src="imageSrc" :preview-src-list="srcList"> </el-image>
                    </el-form>
                </div>
                <div slot="footer">
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button type="primary" @click="submitForm" v-if="shopStoreState != 'check'">确定</el-button>
                </div>
            </el-dialog>
        </div>
        <!--审核功能-->
        <el-dialog title='门店申请审核' :visible.sync='retreatDialogVisible' width='30%'
                   :before-close='handleCloseRetreat'>
            <el-form ref='retreatForm' :rules='retreatRules' size='small' :model='retreatForm' label-width='100px'>
                <el-form-item label='申请说明：'>
                    <el-input style='width: 100%' type='textarea' v-model='applyRemarks'
                              :disabled='true'></el-input>
                </el-form-item>
                <el-form-item label='是否同意：' prop='resource'>
                    <el-radio-group v-model='retreatForm.resource'>
                        <el-radio label='true'>同意</el-radio>
                        <el-radio label='false'>拒绝</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label='拒绝原因：' v-if="retreatForm.resource == 'false'" prop='desc'>
                    <el-input style='width: 100%' type='textarea' v-model='retreatForm.desc'></el-input>
                </el-form-item>
<!--                <el-form-item label='收益比例：' v-if="retreatForm.resource == 'true'" prop='incomeRatio'>-->
<!--                    <el-input style='width: 200px' v-model='retreatForm.incomeRatio'></el-input>-->
<!--                </el-form-item>-->
            </el-form>
            <span slot='footer' class='dialog-footer'>
        <el-button @click='handleCloseRetreat'>取 消</el-button>
        <el-button type='primary' @click="retreatSuccess('retreatForm')">确 定</el-button>
      </span>
        </el-dialog>

        <!-- 添加商品 -->
        <el-dialog title="添加商品" :visible.sync="showAdd" width="400px" @close="closeShop">
            <div>
                <el-form :model="shopProductClassify" ref="shopProductClassifyForm" :rules="ruless" :inline="true"
                         size="small">
                    <el-form-item label="商品" prop="productIdList">
                        <div style="display: flex;">
                            <GridSelectLi
                                ref="add1"
                                style="width: 250px;"
                                title="选择商品"
                                labelName="productName"
                                labelValue="id"
                                :did="did"
                                :value="shopProductClassify.productIdList"
                                :limit="99"
                                size="small"
                                placeholder="请选择商品"
                                @getValue="getValuebrandId"
                                :columns="PRODUCT_code"
                                :searchs="PRODUCT_search"
                                dataListUrl="/shop/product/findList"
                                entityBeanName="shopProduct"
                                queryEntityUrl="/shop/product/get"
                            >
                            </GridSelectLi>
                            <el-button style="height: 30px;margin: 0 4px;" type="primary" @click="add1">添加</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item label="分类" prop="categoryId">
                        <el-select placeholder="请选择状态" clearable style="width: 250px"
                                   size="small" v-model="shopProductClassify.categoryId">
                            <el-option v-for='(item, index) in productStatusEnumList1' :key='index'
                                       :label="item.categoryName"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>

            <div slot="footer" class="flex justify-end">
                <el-button @click="closeShop">关闭</el-button>
                <el-button type="primary" @click="shopaddForm">确定</el-button>
            </div>
        </el-dialog>

        <!-- 弹窗商品列表 -->
        <el-dialog title="商品列表" :visible.sync="shopList" width="1200px">
            <el-button
                type="danger"
                plain
                size="small"
                icon="el-icon-delete"
                :disabled="multipleSelection.length <= 0"
                @click="deleteShopProductClassify(null)"
            >删除
            </el-button
            >
            <el-button
                type="primary"
                plain
                size="small"
                icon="el-icon-plus"
                @click="openShop"
            >添加商品
            </el-button
            >
            <el-table
                :data="shopProductClassifyList"
                row-key="id"
                border
                @selection-change="handleSelectionChange"
                height="500px"
                size="small"
            >
                <el-table-column align="center" type="selection" width="60"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="productId" label="商品" width="180">
                    <template slot-scope="scope">
                        <div v-if="scope.row.product">
                            <div style='text-align: left'>名称：{{ scope.row.product.productName }}</div>
                            <div style='text-align: left'>货号：{{ scope.row.product.productNumber }}</div>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="product.productPic" label="商品图片"
                                 width="180">
                    <template slot-scope="scope">
                        <div v-if='scope.row.product.productPic'>
                            <el-image @click='updateSrcList(scope.row.product.productPic)'
                                      style="width: 60px; height: 60px"
                                      :src="scope.row.product.productPic" :preview-src-list="srcList"></el-image>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="productId" label="价格" width="180">
                    <template slot-scope="scope">
                        <div v-if="scope.row.product">
                            <div style='text-align: left'>商品价格：{{ scope.row.product.shopPrice }}</div>
                            <div style='text-align: left'>市场价格：{{ scope.row.product.marketPrice }}</div>
                            <div style='text-align: left'>供货价格：{{ scope.row.product.supplyPrice }}</div>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="category.categoryName"
                                 label="所属分类" width="180">
                </el-table-column>

                <el-table-column :show-overflow-tooltip="true" align="center" prop="store.storeName" label="门店名称"
                                 width="180">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="createTime"
                                 label="更新时间"></el-table-column>
                <el-table-column fixed="right" align="center" label="操作" width="200">
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="deleteShopProductClassify(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>

                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChanges"
                    @current-change="currentChanges"
                    :current-page.sync="currentPages"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSizes"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNums"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
        </el-dialog>

        <!-- 相册列表 -->
        <el-dialog title="相册" :visible.sync="showBanner" width="60%">
            <ShopStoreAlbum style="height: 600px" ref="banner"></ShopStoreAlbum>
            <div slot="footer" class="flex justify-end">
                <el-button @click="closeBanner">关闭</el-button>
            </div>
        </el-dialog>

<!--        团购管理-->
        <el-dialog title="团购管理" :visible.sync="showSteam" width="60%">
            <ShopStoreGroupbuy style="height: 600px" ref="ShopStoreGroupbuy"></ShopStoreGroupbuy>
            <div slot="footer" class="flex justify-end">
                <el-button @click="closeSteam">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 标签列表 -->
        <el-dialog title="标签" :visible.sync="showTabs" width="600px">
            <div>
                <el-form size="small" :inline="true">
                    <el-form-item label="" prop="categoryId">
                        <div style="display: flex">
                            <el-input style="width: 200px;" v-model="keyboards" type="small"></el-input>
                            <el-button type="primary" @click="addTabs" style="margin-left: 10px">添加</el-button>
                        </div>
                    </el-form-item>
                </el-form>
                <div style="width: 100%;">
                    <el-button type="danger" plain size="small" icon="el-icon-delete" v-for="(item,index) in tabList"
                               @click="deleteTabs(index)">{{ item }}
                    </el-button>
                </div>
            </div>
            <div slot="footer" class="flex justify-end">
                <el-button @click="closeTabs">确定</el-button>
            </div>
        </el-dialog>

        <!-- 云喇叭 -->
        <el-dialog title="云喇叭设置" :visible.sync="showLB" width="600px" @close="closeLb">
            <div>
                <el-form size="small" label-width="120px" :rules="ruleLb" ref="lb" :model="printer">
                    <el-form-item label="云喇叭名称" prop="speakerName">
                        <el-input v-model="printer.speakerName" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="云喇叭序列号" prop="speakerSn">
                        <el-input v-model="printer.speakerSn" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="是否激活" prop="isActivated">
                        <el-radio-group v-model="printer.isActivated">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="flex justify-end">
                <el-button @click="closeLb">取消</el-button>
                <el-button type="primary" @click="subLb">确定</el-button>
            </div>
        </el-dialog>

        <!--进件-->
        <el-dialog title="进件资料" :visible.sync="registerVisible" width="80%" ref="register" @close="closeRegister">
            <el-form
                :model="shopStoreOrgInfo"
                ref="shopStoreOrgInfoForm"
                :rules="rules"
                label-width="120px"
                :inline="true"
                size="small"
            >
                <el-tabs type="border-card">
                    <el-tab-pane label="工商信息">
                        <el-form-item
                            label="组织类型"
                            prop="orgType"
                        >
                            <el-select
                                v-model="shopStoreOrgInfo.orgType"
                                size="small"
                                placeholder="请选择组织类型"
                                clearable
                                style="width: 200px"
                            >
                                <el-option v-for="(item,index) in orgInfoStatus" :label="item.value" :value="item.key"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="执照所属省份"
                            prop="licenseProvinceId"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="shopStoreOrgInfo.licenseProvinceId"-->
<!--                            ></el-input>-->
                            <el-select
                                style='width:200px'
                                v-model='shopStoreOrgInfo.licenseProvinceId'
                                size='small'
                                placeholder='请选择省份'
                            >
                                <el-option
                                    v-for='item in provinceIdList'
                                    :key='item.id'
                                    :label='item.name'
                                    :value='item.id'
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="执照所属城市"
                            prop="licenseCityId"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="shopStoreOrgInfo.licenseCityId"-->
<!--                            ></el-input>-->
                            <el-select
                                style='width:200px'
                                v-model='shopStoreOrgInfo.licenseCityId'
                                size='small'
                                placeholder='请选择城市'
                            >
                                <el-option
                                    v-for='item in cityIdList'
                                    :key='item.id'
                                    :label='item.name'
                                    :value='item.id'
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="执照所属区县"
                            prop="licenseAreaId"
                        >
                            <el-select
                                style='width:200px'
                                v-model='shopStoreOrgInfo.licenseAreaId'
                                size='small'
                                placeholder='请选择区县'
                            >
                                <el-option
                                    v-for='item in areaIdList'
                                    :key='item.id'
                                    :label='item.name'
                                    :value='item.id'
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="执照所属乡镇"
                            prop="licenseTownId"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="shopStoreOrgInfo.licenseTownId"-->
<!--                            ></el-input>-->
                            <el-select
                                style='width:200px'
                                v-model='shopStoreOrgInfo.licenseTownId'
                                size='small'
                                placeholder='请选择乡镇'
                            >
                                <el-option
                                    v-for='item in streetIdList'
                                    :key='item.id'
                                    :label='item.name'
                                    :value='item.id'
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="营业执照名称"
                            prop="licenseName"
                        >
                            <el-input
                                size="small"
                                style="width: 200px"
                                v-model="shopStoreOrgInfo.licenseName"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="营业执照注册地址"
                            prop="licenseAddress"
                        >
                            <el-input
                                size="small"
                                style="width: 200px"
                                v-model="shopStoreOrgInfo.licenseAddress"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="统一社会信用代码"
                            prop="licenseNumber"
                        >
                            <el-input
                                size="small"
                                style="width: 200px"
                                v-model="shopStoreOrgInfo.licenseNumber"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="经营期限起始"
                            prop="licenseStartTime"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 200px"-->
<!--                                v-model="shopStoreOrgInfo.licenseStartTime"-->
<!--                            ></el-input>-->
                              <div style="width: 200px;display: flex;align-items: center;">
                                  <el-date-picker
                                      style="flex: 1"
                                      size="small"
                                      v-model="shopStoreOrgInfo.licenseStartTime"
                                      type="date"
                                      value-format="yyyy-MM-dd"
                                      placeholder="选择日期">
                                  </el-date-picker>
                                  <el-checkbox style="margin-left: 10px" :true-label="1" :false-label="0" v-model="shopStoreOrgInfo.licenseIsPermanent" label="长期"></el-checkbox>
                              </div>

                        </el-form-item>
                        <el-form-item
                            label="经营期限结束"
                            prop="licenseEndTime"
                            v-if="shopStoreOrgInfo.licenseIsPermanent == 0"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 200px"-->
<!--                                v-model="shopStoreOrgInfo.licenseEndTime"-->
<!--                            ></el-input>-->
                            <el-date-picker
                                  style="width: 200px;"
                                  size="small"
                                  v-model="shopStoreOrgInfo.licenseEndTime"
                                  type="date"
                                  value-format="yyyy-MM-dd"
                                  placeholder="选择日期">
                              </el-date-picker>
                        </el-form-item>
                        <el-form-item
                            label="经营范围"
                            prop="licenseRange"
                        >
                            <el-input
                                size="small"
                                style="width: 200px"
                                v-model="shopStoreOrgInfo.licenseRange"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="营业执照图片"
                            prop="licensePic"
                        >
                            <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                       class="avatar-uploader" :show-file-list="false"
                                       :http-request="uploadImage21">
                                <img v-if="shopStoreOrgInfo.licensePic" :src="shopStoreOrgInfo.licensePic" class="avatar" size="small" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
<!--                        <el-form-item-->
<!--                            label="其他补充资料 如烟草经营许可证"-->
<!--                            prop="otherInfor"-->
<!--                        >-->
<!--                            <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"-->
<!--                                       class="avatar-uploader" :show-file-list="false"-->
<!--                                       :http-request="uploadImage22">-->
<!--                                <img v-if="shopStoreOrgInfo.otherInfor" :src="shopStoreOrgInfo.otherInfor" class="avatar" size="small" />-->
<!--                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
<!--                            </el-upload>-->
<!--                        </el-form-item>-->
                    </el-tab-pane>

                    <el-tab-pane label="法人信息">
                        <el-form-item
                            label="法人姓名"
                            prop="personName"
                        >
                            <el-input
                                size="small"
                                style="width: 200px"
                                v-model="shopStoreOrgInfo.personName"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="身份证号"
                            prop="idCard"
                        >
                            <el-input
                                size="small"
                                style="width: 200px"
                                v-model="shopStoreOrgInfo.idCard"
                            ></el-input>
                        </el-form-item>
<!--                        <el-form-item-->
<!--                            label="是否长期"-->
<!--                            prop="idCardIsPermanent"-->
<!--                        >-->
<!--                            <el-select-->
<!--                                style='width:200px'-->
<!--                                v-model='shopStoreOrgInfo.idCardIsPermanent'-->
<!--                                size='small'-->
<!--                                placeholder='请选择是否长期'-->
<!--                            >-->
<!--                                <el-option-->
<!--                                    label='是'-->
<!--                                    :value='1'-->
<!--                                ></el-option>-->
<!--                                <el-option-->
<!--                                    label='否'-->
<!--                                    :value='0'-->
<!--                                ></el-option>-->
<!--                            </el-select>-->
<!--                        </el-form-item>-->
                        <el-form-item
                            label="证件有效期起始"
                            prop="idCardStartTime"
                        >
                           <div style="width: 200px;display: flex;align-items: center">
                               <el-date-picker
                                   style="flex: 1"
                                   size="small"
                                   v-model="shopStoreOrgInfo.idCardStartTime"
                                   type="date"
                                   value-format="yyyy-MM-dd"
                                   placeholder="选择日期">
                               </el-date-picker>
                               <el-checkbox style="margin-left: 10px" :true-label="1" :false-label="0" v-model="shopStoreOrgInfo.idCardIsPermanent" label="长期"></el-checkbox>
                           </div>
                        </el-form-item>
                        <el-form-item
                            label="证件有效期结束"
                            prop="idCardEndTime"
                            v-if="shopStoreOrgInfo.idCardIsPermanent==0"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 200px"-->
<!--                                v-model="shopStoreOrgInfo.idCardEndTime"-->
<!--                            ></el-input>-->
                            <el-date-picker
                                  style="width: 200px;"
                                  size="small"
                                  v-model="shopStoreOrgInfo.idCardEndTime"
                                  type="date"
                                  value-format="yyyy-MM-dd"
                                  placeholder="选择日期">
                              </el-date-picker>
                        </el-form-item>
                        <el-form-item
                            label="证件地址"
                            prop="idCardAddress"
                        >
                            <el-input
                                size="small"
                                style="width: 200px"
                                v-model="shopStoreOrgInfo.idCardAddress"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="身份证人像面图片"
                            prop="idCardFacade"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 200px"-->
<!--                                v-model="shopStoreOrgInfo.idCardFacade"-->
<!--                            ></el-input>-->
                            <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                       class="avatar-uploader" :show-file-list="false"
                                       :http-request="uploadImage31">
                                <img v-if="shopStoreOrgInfo.idCardFacade" :src="shopStoreOrgInfo.idCardFacade" class="avatar" size="small" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                        <el-form-item
                            label="身份证国徽面图片"
                            prop="idCardBack"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 200px"-->
<!--                                v-model="shopStoreOrgInfo.idCardBack"-->
<!--                            ></el-input>-->
                            <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                       class="avatar-uploader" :show-file-list="false"
                                       :http-request="uploadImage32">
                                <img v-if="shopStoreOrgInfo.idCardBack" :src="shopStoreOrgInfo.idCardBack" class="avatar" size="small" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                    </el-tab-pane>

                    <el-tab-pane label="银行信息">
                        <el-form-item
                            label="对公账户名称/持有人姓名"
                            prop="bankHolder"
                        >
                            <el-input
                                size="small"
                                style="width: 200px"
                                v-model="shopStoreOrgInfo.bankHolder"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="对公账户卡号/银行卡卡号"
                            prop="bankAccount"
                        >
                            <el-input
                                size="small"
                                style="width: 200px"
                                v-model="shopStoreOrgInfo.bankAccount"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="所属银行"
                            prop="bankName"
                        >
                            <el-input
                                size="small"
                                style="width: 200px"
                                v-model="shopStoreOrgInfo.bankName"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="开户支行"
                            prop="bankSubbranch"
                        >
                            <el-input
                                size="small"
                                style="width: 200px"
                                v-model="shopStoreOrgInfo.bankSubbranch"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="银行所在省份"
                            prop="bankProvinceId"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="shopStoreOrgInfo.bankProvinceId"-->
<!--                            ></el-input>-->
                            <el-select
                                style='width:200px'
                                v-model='shopStoreOrgInfo.bankProvinceId'
                                size='small'
                                placeholder='请选择省份'
                            >
                                <el-option
                                    v-for='item in provinceIdList'
                                    :key='item.id'
                                    :label='item.name'
                                    :value='item.id'
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="银行所在城市"
                            prop="bankCityId"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="shopStoreOrgInfo.bankCityId"-->
<!--                            ></el-input>-->
                           <el-select
                                style='width:200px'
                                v-model='shopStoreOrgInfo.bankCityId'
                                size='small'
                                placeholder='请选择城市'
                            >
                                <el-option
                                    v-for='item in cityIdList2'
                                    :key='item.id'
                                    :label='item.name'
                                    :value='item.id'
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="银行所在区县"
                            prop="bankAreaId"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="shopStoreOrgInfo.bankAreaId"-->
<!--                            ></el-input>-->
                            <el-select
                                style='width:200px'
                                v-model='shopStoreOrgInfo.bankAreaId'
                                size='small'
                                placeholder='请选择区县'
                            >
                                <el-option
                                    v-for='item in areaIdList2'
                                    :key='item.id'
                                    :label='item.name'
                                    :value='item.id'
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="银行所在乡镇"
                            prop="bankTownId"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="shopStoreOrgInfo.bankTownId"-->
<!--                            ></el-input>-->
                            <el-select
                                style='width:200px'
                                v-model='shopStoreOrgInfo.bankTownId'
                                size='small'
                                placeholder='请选择乡镇'
                            >
                                <el-option
                                    v-for='item in streetIdList2'
                                    :key='item.id'
                                    :label='item.name'
                                    :value='item.id'
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="银行预留手机号"
                            prop="bankMobile"
                        >
                            <el-input
                                size="small"
                                style="width: 200px"
                                v-model="shopStoreOrgInfo.bankMobile"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="子商户号"
                            prop="subAccount"
                        >
                            <el-input
                                size="small"
                                style="width: 200px"
                                v-model="shopStoreOrgInfo.subAccount"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="银行卡正面图片"
                            prop="bankCardFacade"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 200px"-->
<!--                                v-model="shopStoreOrgInfo.bankCardFacade"-->
<!--                            ></el-input>-->
                            <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                       class="avatar-uploader" :show-file-list="false"
                                       :http-request="uploadImage41">
                                <img v-if="shopStoreOrgInfo.bankCardFacade" :src="shopStoreOrgInfo.bankCardFacade" class="avatar" size="small" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                        <el-form-item
                            label="银行卡背面图片"
                            prop="bankCardBack"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 200px"-->
<!--                                v-model="shopStoreOrgInfo.bankCardBack"-->
<!--                            ></el-input>-->
                            <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                       class="avatar-uploader" :show-file-list="false"
                                       :http-request="uploadImage42">
                                <img v-if="shopStoreOrgInfo.bankCardBack" :src="shopStoreOrgInfo.bankCardBack" class="avatar" size="small" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                        <el-form-item
                            label="对公账户凭证"
                            prop="bankAccountVoucher"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 200px"-->
<!--                                v-model="shopStoreOrgInfo.bankAccountVoucher"-->
<!--                            ></el-input>-->
                            <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                       class="avatar-uploader" :show-file-list="false"
                                       :http-request="uploadImage43">
                                <img v-if="shopStoreOrgInfo.bankAccountVoucher" :src="shopStoreOrgInfo.bankAccountVoucher" class="avatar" size="small" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                    </el-tab-pane>
                    <el-tab-pane label="其他信息">
                        <el-form-item
                            label="支付审核状态"
                            prop="thirdStatus"
                        >
                            <el-select
                                v-model="shopStoreOrgInfo.thirdStatus"
                                size="small"
                                placeholder="请选择支付审核状态"
                                clearable
                                style="width: 200px"
                            >
                                <el-option v-for="(item,index) in auditStatus" :label="item.value" :value="item.key"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="支付宝支付审核状态"
                            prop="alipayStatus"
                        >
                            <!--                            <el-input-->
                            <!--                                size="small"-->
                            <!--                                v-model="shopStoreOrgInfo.alipayStatus"-->
                            <!--                            ></el-input>-->
                            <el-select
                                v-model="shopStoreOrgInfo.alipayStatus"
                                size="small"
                                placeholder="请选择支付宝支付审核状态"
                                clearable
                                style="width: 200px"
                            >
                                <el-option label="未审核" :value="0"> </el-option>
                                <el-option label="已审核" :value="1"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="微信支付审核状态"
                            prop="wxpayStatus"
                        >
                            <!--                            <el-input-->
                            <!--                                size="small"-->
                            <!--                                v-model="shopStoreOrgInfo.wxpayStatus"-->
                            <!--                            ></el-input>-->
                            <el-select
                                v-model="shopStoreOrgInfo.wxpayStatus"
                                size="small"
                                placeholder="请选择微信支付审核状态"
                                clearable
                                style="width: 200px"
                            >
                                <el-option label="未审核" :value="0"> </el-option>
                                <el-option label="已审核" :value="1"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="签名图片"
                            prop="signPic"
                        >
                            <!--                            <el-input-->
                            <!--                                size="small"-->
                            <!--                                style="width: 200px"-->
                            <!--                                v-model="shopStoreOrgInfo.signPic"-->
                            <!--                            ></el-input>-->
                            <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                       class="avatar-uploader" :show-file-list="false"
                                       :http-request="uploadImage11">
                                <img v-if="shopStoreOrgInfo.signPic" :src="shopStoreOrgInfo.signPic" class="avatar" size="small" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                        <el-form-item
                            label="合同地址"
                            prop="contractUrl"
                        >
                            <!--                            <el-input-->
                            <!--                                size="small"-->
                            <!--                                style="width: 200px"-->
                            <!--                                v-model="shopStoreOrgInfo.contractUrl"-->
                            <!--                            ></el-input>-->
                            <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                       class="avatar-uploader" :show-file-list="false"
                                       :http-request="uploadImage12">
                                <img v-if="shopStoreOrgInfo.contractUrl" :src="shopStoreOrgInfo.contractUrl" class="avatar" size="small" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                        <el-form-item
                            label="响应报文"
                            prop="resultMsg"
                        >
                            <el-input
                                size="small"
                                type="textarea"
                                :rows="8"
                                style="width: 200px"
                                v-model="shopStoreOrgInfo.resultMsg"
                            ></el-input>
                        </el-form-item>
                    </el-tab-pane>
                </el-tabs>
            </el-form>
            <div slot="footer">
                <el-button @click="closeRegister">关闭</el-button>
                <el-button type="primary" @click="submitRegister">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import Location from '@/components/location/location.vue';
import ShopStoreGroupbuy from '@/components/StoreManagement/ShopStoreGroupbuy.vue';
import {
    UPLOAD_PATH,
    UPLOAD_API,
    USER,
    PRODUCT1,
    PRODUCT_SEARCH1,
    USER_SEARCH,
    PROMOTER,
    PROMOTER_SEARCH,
    PERSON,
    PERSON_SEARCH,
    SORTING,
    SORTING_SEARCH
} from '@/utils/constant.js';
import GridSelectU from '@/components/gridselect';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
import ShopStoreAlbum from '@/components/StoreManagement/ShopStoreAlbum.vue';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        Location,
        GridSelectU,
        GridSelectLi,
        ShopStoreAlbum,
        ShopStoreGroupbuy
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopStoreList();
                this.getShopStoreList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopStoreList();
                this.getShopStoreList();
                this.$emit('resetCheckState');
            }
        },
        "shopStore.serviceType":{
            handler(val){
                if (!this.getRatio) {
                    for (let i = 0; i < this.serviveTypeList.length; i++) {
                        if(this.serviveTypeList[i].key == val){
                            this.shopStore.serviceRatio = this.serviveTypeList[i].value
                        }
                    }
                } else {
                    this.getRatio = !this.getRatio;
                }
            }
        },

        'shopStoreOrgInfo.licenseIsPermanent'(val) {
            if(val == 1){
                this.shopStoreOrgInfo.licenseEndTime = ''
            }
        },

        'shopStoreOrgInfo.idCardIsPermanent'(val) {
            if(val == 1){
                this.shopStoreOrgInfo.idCardEndTime = ''
            }
        },

        //市
        'shopStoreOrgInfo.licenseProvinceId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getCity) {
                    this.shopStoreOrgInfo.licenseCityId = '';
                    this.shopStoreOrgInfo.licenseAreaId = '';
                    this.shopStoreOrgInfo.licenseTownId = '';
                } else {
                    this.getCity = !this.getCity;
                }
                this.getAddress(2,id)
            }, 5);
        },
        //区
        'shopStoreOrgInfo.licenseCityId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getArea) {
                    this.shopStoreOrgInfo.licenseAreaId = '';
                    this.shopStoreOrgInfo.licenseTownId = '';
                } else {
                    this.getArea = !this.getArea;
                }
                this.getAddress(3,id)
            }, 10);
        },
        //社区
        'shopStoreOrgInfo.licenseAreaId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.street) {
                    this.shopStoreOrgInfo.licenseTownId = '';
                } else {
                    this.street = !this.street;
                }
                this.getAddress(4,id)
            }, 15);
        },


        //市
        'shopStoreOrgInfo.bankProvinceId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getCity2) {
                    this.shopStoreOrgInfo.bankCityId = '';
                    this.shopStoreOrgInfo.bankAreaId = '';
                    this.shopStoreOrgInfo.bankTownId = '';
                } else {
                    this.getCity2 = !this.getCity2;
                }
                this.getAddress2(2,id)
            }, 25);
        },
        //区
        'shopStoreOrgInfo.bankCityId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getArea2) {
                    this.shopStoreOrgInfo.bankAreaId = '';
                    this.shopStoreOrgInfo.bankTownId = '';
                } else {
                    this.getArea2 = !this.getArea2;
                }
                this.getAddress2(3,id)
            }, 30);
        },
        //社区
        'shopStoreOrgInfo.bankAreaId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.street2) {
                    this.shopStoreOrgInfo.bankTownId = '';
                } else {
                    this.street2 = !this.street2;
                }
                this.getAddress2(4,id)
            }, 35);
        },


        //市
        'shopStore.provinceId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getCity3) {
                    this.shopStore.cityId = '';
                    this.shopStore.areaId = '';
                    this.shopStore.streetId = '';
                } else {
                    this.getCity3 = !this.getCity3;
                }
                this.getAddress3(2,id)
            }, 5);
        },
        //区
        'shopStore.cityId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getArea3) {
                    this.shopStore.areaId = '';
                    this.shopStore.streetId = '';
                } else {
                    this.getArea3 = !this.getArea3;
                }
                this.getAddress3(3,id)
            }, 10);
        },
        //社区
        'shopStore.areaId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.street3) {
                    this.shopStore.streetId = '';
                } else {
                    this.street3 = !this.street3;
                }
                this.getAddress3(4,id)
            }, 15);
        },
    },
    data() {
        return {
            shopStoreOrgInfo: {
                userId: '', //用户id
                storeId: '', //门店id
                storeIndustry: '', //商户行业
                subAccount: '', //子商户号
                orgType: '', //组织类型 1小微 2企业 3个体
                licensePic: '', //营业执照图片
                licenseProvinceId: '', //营业执照省
                licenseCityId: '', //营业执照市
                licenseAreaId: '', //营业执照区
                licenseTownId: '', //营业执照乡镇
                licenseName: '', //营业执照名称
                licenseAddress: '', //营业执照地址
                licenseNumber: '', //社会统一信用代码
                licenseIsPermanent: 0,
                licenseStartTime: '', //营业执照有效开始日期
                licenseEndTime: '', //营业执照有效结束日期
                licenseRange: '', //营业执照经营范围
                personName: '', //真实姓名
                personMobile: '', //法人手机号
                idCard: '', //身份证号
                idCardIsPermanent: 0,
                idCardStartTime: '', //身份证有效开始日期
                idCardEndTime: '', //身份证有效结束日期
                idCardFacade: '', //身份证正面图片
                idCardBack: '', //身份证背面图片
                idCardAddress: '', //身份证地址
                bankAccount: '', //银行账号
                bankHolder: '', //银行卡持有人
                bankMobile: '', //银行预留手机号
                bankCardFacade: '', //银行卡正面图片
                bankCardBack: '', //银行卡背面图片
                bankAccountVoucher: '', //对公账户凭证
                bankName: '', //银行名称
                bankSubbranch: '', //开户支行名称
                bankProvinceId: '', //开户行省
                bankCityId: '', //开户行市
                bankAreaId: '', //开户行市
                bankTownId: '', //开户行乡镇
                thirdStatus: '', //支付审核状态
                alipayStatus: '', //支付宝支付审核状态
                wxpayStatus: '', //微信支付审核状态
                resultMsg: '', //响应报文
                signPic: '', //签名图片
                contractUrl: '', //合同地址
                otherInfor: '', //其他补充资料 如烟草经营许可证
            },
            registerVisible: false,
            shopProductClassifyList: [],
            shopList: false,
            totalNums: 0,
            cid: '',
            currentPages: 1,
            pageSizes: 10,
            shopListForm: {
                storeId: '',
                productName: '', //商品id
                activityName: '' //类别类型
            },
            showTabs: false,
            keyboards: '',


            sortingList: [],
            shopProductClassify: {
                id: '', //id
                productIdList: [], //商品id
                storeId: '', //类别类型
                categoryId: ''
            },
            showAdd: false,
            PRODUCT_code: PRODUCT1,
            PRODUCT_search: PRODUCT_SEARCH1,
            did: '',

            USER_code: USER,
            USER_search: USER_SEARCH,
            PROMOTER_code: PROMOTER,
            PROMOTER_search: PROMOTER_SEARCH,
            PERSON_code: PERSON,
            PERSON_search: PERSON_SEARCH,
            SORTING_code: SORTING,
            SoRTING_search: SORTING_SEARCH,
            queryForm: {
                id: '', //ID
                storeName: '', //门店名称
                storeLogo: '', //门店图片
                provinceId: '', //省
                cityId: '', //市
                areaId: '', //区
                storeAddress: '', //详细地址
                storePosition: '', //定位
                longitude: '', //经度
                latitude: '', //纬度
                openStatus: '', //营业状态
                openHours: '', //营业时间
                contactPerson: '', //联系人姓名
                contactPhone: '', //联系人电话
                remarks: '', //备注
                userId: '', //店铺管理
                createTime: '' //创建时间
            },
            header: {
                token: localStorage.getItem('token')
            },
            action: UPLOAD_API + UPLOAD_PATH,
            areaTreeDate: [],
            srcList: [''],
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopStoreState: 'add',
            shopStoreStates: {
                add: '新建门店',
                check: '查看门店',
                edit: '修改门店'
            },

            multipleSelection: [],
            shopStoreList: [],
            shopStore: {
                storeName: '', //门店名称
                incomeRatio: '',
                storeLogo: '', //门店图片
                provinceId: '', //省
                cityId: '', //市
                areaId: '', //区
                streetId: '',
                storeAddress: '', //详细地址
                storePosition: '', //定位
                longitude: '', //经度
                latitude: '', //纬度
                openStatus: '', //营业状态
                openHours: ['08:00', '20:00'], //营业时间
                contactPerson: '', //联系人姓名
                contactPhone: '', //联系人电话
                remarks: '', //备注
                userId: '', //店铺管理
                promoterId: '',
                personId: '',
                deliverId: '',
                sortingId: '',
                storeTags: '',
                storeBanner: '',
                typeId: '',
                grade: '',
                status: '',
                serviceType: '',
                serviceRatio: '',
                signServiceType: '',
                industryId: '',
                storeInterior1: "",
                storeInterior2: "",
                storeInterior: '',
                isShow: '',
            },
            industryList: [],
            treeProps: {
                children: 'children',
                label: 'industryName'
            },
            btnLoading: false,
            productStatusEnumList: [],
            productStatusEnumList1: [],
            ruless: {
                productIdList: [{ required: true, message: '商品不能为空', trigger: 'blur' }],
                categoryId: [{ required: true, message: '类别不能为空', trigger: 'blur' }]
            },
            rules: {
                storeName: [{ required: true, message: '门店名称不能为空', trigger: 'blur' }],
                incomeRatio: [{ required: true, message: '收益比例不能为空', trigger: 'blur' }],
                storeLogo: [{ required: true, message: '门店图片不能为空', trigger: 'blur' }],
                provinceId: [{ required: true, message: '省不能为空', trigger: 'blur' }],
                cityId: [{ required: true, message: '市不能为空', trigger: 'blur' }],
                areaId: [{ required: true, message: '区不能为空', trigger: 'blur' }],
                // streetId: [{ required: true, message: '乡镇不能为空', trigger: 'blur' }],
                storeAddress: [{ required: true, message: '详细地址不能为空', trigger: 'blur' }],
                storePosition: [{ required: true, message: '定位不能为空', trigger: 'blur' }],
                longitude: [{ required: true, message: '经度不能为空', trigger: 'blur' }],
                latitude: [{ required: true, message: '纬度不能为空', trigger: 'blur' }],
                openStatus: [{ required: true, message: '营业状态不能为空', trigger: 'blur' }],
                openHours: [{ required: true, message: '营业时间不能为空', trigger: 'blur' }],
                contactPerson: [{ required: true, message: '联系人姓名不能为空', trigger: 'blur' }],
                contactPhone: [{ required: true, message: '联系人电话不能为空', trigger: 'blur' }],
                userId: [{ required: true, message: '店铺管理不能为空', trigger: 'blur' }],
                promoterId: [{ required: true, message: '推广人不能为空', trigger: 'blur' }],
                deliverId: [{ required: true, message: '配送人不能为空', trigger: 'blur' }],
                sortingId: [{ required: true, message: '门店分拣不能为空', trigger: 'blur' }],
                storeBanner: [{ required: true, message: '门头照片不能为空', trigger: 'blur' }],
                typeId: [{ required: true, message: '门头分类不能为空', trigger: 'blur' }],
                industryId: [{ required: true, message: '所属行业不能为空', trigger: 'blur' }],
                grade: [{ required: true, message: '门头等级不能为空', trigger: 'blur' }],
                serviceType: [{ required: true, message: '服务费类型不能为空', trigger: 'blur' }],
                serviceRatio: [{ required: true, message: '服务费比列不能为空', trigger: 'blur' }],
                signServiceType: [{ required: true, message: '签约服务费类型不能为空', trigger: 'blur' }],
                storeInterior1: [{ required: true, message: '收银台图不能为空', trigger: 'blur' }],
                storeInterior2: [{ required: true, message: '门店内景图片2不能为空', trigger: 'blur' }],
                status: [{ required: true, message: '审核状态不能为空', trigger: 'blur' }],
                isShow: [{ required: true, message: '是否显示不能为空', trigger: 'blur' }],
            },
            auditId: '',
            retreatDialogVisible: false,
            applyRemarks: '',
            retreatRules: {
                resource: [{ required: true, message: '请选择是否同意', trigger: 'change' }],
                desc: [{ required: true, message: '请填写拒绝原因', trigger: 'blur' }],
                incomeRatio: [{ required: true, message: '请填写门店收益比例', trigger: 'blur' }]
            },
            retreatForm: {
                resource: '',
                desc: '',
                incomeRatio: ''
            },
            auditStatus: [],

            showBanner: false,

            tabList: [],


            showLB: false,
            printer: {
                isActivated: 1,
                speakerName: '',
                speakerSn: '',
                storeId: "",
            },
            ruleLb: {
                isActivated: [{ required: true, message: '是否激活不能为空', trigger: 'blur' }],
                speakerName: [{ required: true, message: '云喇叭名称不能为空', trigger: 'blur' }],
                speakerSn: [{ required: true, message: '云喇叭序列号不能为空', trigger: 'blur' }]
            },
            typeIdArry: [],
            gradeList: [],
            serviveTypeList: [],
            signingServiceTypeList: [],
            orgInfoStatus: [],



            provinceIdList: [], //省信息
            cityIdList: [], //市信息
            areaIdList: [], //区信息
            streetIdList: [],
            getCity: false,//区别是不是get来的
            getArea: false,//区别是不是get来的
            street: false,

            cityIdList2: [], //市信息
            areaIdList2: [], //区信息
            streetIdList2: [],
            getCity2: false,//区别是不是get来的
            getArea2: false,//区别是不是get来的
            street2: false,

            cityIdList3: [], //市信息
            areaIdList3: [], //区信息
            streetIdList3: [],
            getCity3: false,//区别是不是get来的
            getArea3: false,//区别是不是get来的
            street3: false,

            showSteam: false,

            getRatio: false,

            imageSrc: '',
            auditV3Status: [],
        };
    },
    created() {
        this.getShopStoreList();
        this.getProductStatusEnum();
        this.getAuditStatus();
        this.getProductStatusEnum1();
        this.getAuditV3Status();
        this.getsortingList();
        this.getTypeIdArry();
        this.getEumn();
        this.getIndustryList();
        this.getAddress(1);
    },
    methods: {
        // 获取对应地址
        getAddress(type, id=null) {
            get("/mpp/utils/findAreaList",{areaType:type,pid:id}).then((res)=>{
                if(res.success){
                    let array = []
                    for (let listElement of res.list) {
                        listElement.id = String(listElement.id)
                        array.push(listElement)
                    }
                    if(type == 1){
                        this.provinceIdList = array
                    }else if(type == 2){
                        this.cityIdList = array
                    }else if(type == 3){
                        this.areaIdList = array
                    }else if(type == 4){
                        this.streetIdList = array
                    }
                }
            })
        },

        getImage(url){
            this.imageSrc = url;
            this.srcList[0] = url;
            this.$refs.images.showViewer = true;
        },

        // 获取对应地址
        getAddress2(type, id=null) {
            get("/mpp/utils/findAreaList",{areaType:type,pid:id}).then((res)=>{
                if(res.success){
                    let array = []
                    for (let listElement of res.list) {
                        listElement.id = String(listElement.id)
                        array.push(listElement)
                    }
                    if(type == 2){
                        this.cityIdList2 = array
                    }else if(type == 3){
                        this.areaIdList2 = array
                    }else if(type == 4){
                        this.streetIdList2 = array
                    }
                }
            })
        },

        // 获取对应地址
        getAddress3(type, id=null) {
            get("/mpp/utils/findAreaList",{areaType:type,pid:id}).then((res)=>{
                if(res.success){
                    let array = []
                    for (let listElement of res.list) {
                        listElement.id = String(listElement.id)
                        array.push(listElement)
                    }
                    if(type == 2){
                        this.cityIdList3 = array
                    }else if(type == 3){
                        this.areaIdList3 = array
                    }else if(type == 4){
                        this.streetIdList3 = array
                    }
                }
            })
        },


        // 获取门店分类
        getTypeIdArry(){
            get("/shop/storetype/findAll").then((res)=>{
                if(res.success){
                    this.typeIdArry = res.list;
                }
            })
        },

        // 获取所属行业
        getIndustryList(){
            get('/shop/storeindustry/findAllAsTree').then((res)=>{
                if(res.success){
                    this.industryList = res.treeData
                }
            })
        },

        getEumn(){
            get('/shop/utils/getEnum', { enumType: 'store_grade_type' }).then((res)=>{
                if(res.success){
                    this.gradeList = res.enumList;
                }
            })
            get('/shop/utils/getEnum', { enumType: 'store_service_type' }).then((res) => {
                if (res.success && res.code == 200) {
                    this.serviveTypeList = res.enumList;
                }
            });
            get('/shop/utils/getEnum', { enumType: 'store_org_type_status' }).then((res)=>{
                if (res.success && res.code == 200) {
                    this.orgInfoStatus = res.enumList;
                }
            })
        },
        addLB(id) {
            this.printer.storeId = id;
            this.getShopPrinter(id);
        },
        closeLb() {
            this.showLB = false;
            this.printer = {
                isActivated: 1,
                speakerName: '',
                speakerSn: '',
                storeId: "",
            };
        },
        getShopPrinter(id) {
            get('/shop/storespeaker/getStoreSpeaker',{id: id}).then((res) => {
                if (res.success) {
                    if(res.printer){
                        this.printer = res.printer;
                    }
                    this.showLB = true;
                }
            });
        },
        subLb() {
            this.$refs.lb.validate((valid) => {
                if (valid) {
                    post('/shop/storespeaker/editStoreSpeaker', this.printer).then((res) => {
                        if (res.success) {
                            this.$message.success(res.msg);
                            this.closeLb();
                        } else {
                            this.$message.error(res.msg);
                        }
                    });
                }
            });
        },


        //删除
        add1() {
            this.$refs.add1.showSelectDialog();
            console.log(this.$refs.add1);
        },
        addBanner(id) {
            this.showBanner = true;
            this.$nextTick(() => {
                this.$refs.banner.init(id);
            });
        },
        closeBanner() {
            this.showBanner = false;
        },
        openSteam(id){
            this.showSteam = true;
            this.$nextTick(()=>{
                this.$refs.ShopStoreGroupbuy.init(id)
            })
        },
        closeSteam(){
            this.showSteam = false
        },
        getsortingList() {
            get('/shop/sorting/findAll').then((res) => {
                if (res.success) {
                    this.sortingList = res.list;
                }
            });
        },
        deleteShopProductClassify(shopProductClassifyId) {
            let ids = '';
            if (shopProductClassifyId) {
                ids = shopProductClassifyId;
            } else {
                ids = this.multipleSelection.map((shopProductClassify) => shopProductClassify.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/storeproduct/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            console.log(this.cid);
                            this.openList(this.cid);
                        }
                    });
                })
                .catch(() => {
                });
        },
        //商品列表
        openList(id) {
            this.shopProductClassifyList = [];
            this.shopList = true;
            this.loading = true;
            this.shopListForm.storeId = id;
            console.log(this.shopListForm);
            get(`/shop/storeproduct/findList`, {
                ...this.shopListForm,
                pageNum: this.currentPages,
                pageSize: this.pageSizes
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    console.log(res.page.list);
                    this.totalNums = 0;
                    this.shopProductClassifyList = res.page.list;
                    if(this.shopProductClassifyList.length > 0){
                        this.cid = this.shopProductClassifyList[0].storeId;
                    }else{
                        this.cid = id
                    }
                    this.totalNums = res.page.total;
                }
            });
        },


        addTabs() {
            if (this.keyboards) {
                this.tabList.push(this.keyboards);
                this.keyboards = '';
            }
        },
        deleteTabs(key) {
            this.tabList.splice(key, 1);
        },
        openTabs() {
            this.showTabs = true;
            this.tabList = this.shopStore.storeTags == '' ? [] : this.shopStore.storeTags.split(',');
        },
        closeTabs() {
            this.showTabs = false;
            this.shopStore.storeTags = this.tabList.join(',');
            this.tabList = [];
        },


        getValuebrandId(value) {
            console.log('1111111111111111111111111111111111111111111');
            this.shopProductClassify.productIdList = value;

            // console.log('1111111',this.shopProductClassify.productIdList)
            // console.log('2222222',this.shopProductClassify.productId)
        },
        closeShop() {
            this.shopProductClassify = {
                // id: '', //id
                productId: [], //商品id
                activityId: '' //类别类型
            };
            this.$refs.shopProductClassifyForm.resetFields();
            this.showAdd = false;
        },
        //添加商品信息
        openShop() {
            this.showAdd = true;
            console.log(this.cid);
            this.shopProductClassify.storeId = this.cid;
            this.did = this.cid;
            console.log(this.did);
            console.log(this.shopProductClassify);
        },
        shopaddForm() {
            this.$refs.shopProductClassifyForm.validate((valid) => {
                if (valid) {
                    console.log('submit');
                    console.log(this.shopProductClassify);
                    post(`/shop/storeproduct/addBatch`, { ...this.shopProductClassify }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.closeShop();
                            this.openList(this.did)
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                }
            });
        },


        getSeachValuepersonId(val) {
            console.log(val);
            this.shopStore.deliverId = val;
            // console.log( this.shopStore)
        },
        getSeachValuepersonId1(val) {
            console.log(val);
            this.shopStore.sortingId = val;
            // console.log( this.shopStore)
        },
        // 计算AuditStatus
        computeAuditStatus(type) {
            for (let i = 0; i < this.auditStatus.length; i++) {
                if (this.auditStatus[i].key == type) {
                    return this.auditStatus[i].value;
                }
            }
        },
        // 获取AuditStatusEnum枚举
        getAuditStatus() {
            get('/mpp/utils/getEnum', { enumType: 'audit_status' }).then((res) => {
                this.auditStatus = res.enumList;
            });
        },
        // 获取audit_v3_status枚举
        getAuditV3Status() {
            get('/shop/utils/getEnum', { enumType: 'audit_v3_status' }).then((res) => {
                this.auditV3Status = res.enumList;
            });
        },
        returnV3Status(type){
            for (let i = 0; i < this.auditV3Status.length; i++) {
                if (this.auditV3Status[i].key == type) {
                    return this.auditV3Status[i].value;
                }
            }
        },
        //
        ShopStoreAudit(item) {
            console.log('applyRemarks', item);
            this.retreatDialogVisible = true;
            this.auditId = item.id;
            this.applyRemarks = item.remarks;
            this.retreatDialogVisible = true;
        },

        // 审核取消按钮
        handleCloseRetreat() {
            this.retreatDialogVisible = false;
            this.auditId = '';//关闭后清除点击的id
            this.applyRemarks = ''; //关闭后清除申请人的说明
            this.retreatForm.resource = '';//关闭后把选择的按钮置空
            this.retreatForm.desc = '';
            this.retreatForm.incomeRatio = '';
        },

        //审核确认按钮
        retreatSuccess(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    //处理选择同意&拒绝
                    let status = 1;
                    this.retreatForm.resource == 'true' ? status = 2 : status = 3;
                    this.retreatDialogVisible = false;
                    get(`/shop/store/auditStore`, {
                        id: this.auditId,
                        status: status,
                        refuseReason: this.retreatForm.desc,
                        incomeRatio: this.retreatForm.incomeRatio
                    }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.handleCloseRetreat();
                            this.getShopStoreList();
                        }else{
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                }
            });
        },
        getSeachValuebrandId(val) {
            this.shopStore.promoterId = val;
            console.log(this.shopStore);
        },
        // 获取商品状态枚举
        getProductStatusEnum() {
            get('/mpp/utils/getEnum', {
                enumType: 'opening_status'
            }).then((res) => {
                if (res.success) {
                    this.productStatusEnumList = res.enumList;
                    console.log(this.productStatusEnumList);
                }
            });
        },
        // 获取商品状态枚举
        getProductStatusEnum1() {
            get(`/shop/storeproductcategory/findAllAsTree`, {}).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.productStatusEnumList1 = res.treeData;
                }
            });
        },
        clearSubitem(id) {
            if (id == 'province') {
                this.shopStore.cityId = '';
                this.shopStore.areaId = '';
            } else if (id == 'city') {
                this.shopStore.areaId = '';
            }
        },
        getSearchValueUser(val){
            this.queryForm.userId = val;
        },
        getValueUser(value) {
            this.shopStore.userId = value;
        },
        //上传缩略图
        uploadImage(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStore.storeLogo = res.url;
                }
            });
        },
        //上传缩略图
        uploadImage1(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStore.storeBanner = res.url;
                }
            });
        },


        // 进件
        //上传缩略图
        uploadImage11(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrgInfo.signPic = res.url;
                }
            });
        },
        uploadImage12(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrgInfo.contractUrl = res.url;
                }
            });
        },
        uploadImage21(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrgInfo.licensePic = res.url;
                }
            });
        },
        uploadImage22(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrgInfo.otherInfor = res.url;
                }
            });
        },
        uploadImage31(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrgInfo.idCardFacade = res.url;
                }
            });
        },
        uploadImage32(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrgInfo.idCardBack = res.url;
                }
            });
        },
        uploadImage41(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrgInfo.bankCardFacade = res.url;
                }
            });
        },
        uploadImage42(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrgInfo.bankCardBack = res.url;
                }
            });
        },
        uploadImage43(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrgInfo.bankAccountVoucher = res.url;
                }
            });
        },
        uploadImage51(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStore.storeInterior1 = res.url;
                }
            });
        },
        uploadImage52(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStore.storeInterior2 = res.url;
                }
            });
        },









        beforeImageUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 50;
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 50MB!');
            }
            return isLt2M;
        },
        getLocation(location) {
            console.log("-----------------------------------")
            console.log(location)
            this.shopStore.storePosition = `${location.lng},${location.lat}`;
            this.shopStore.storeAddress = location.address;
            this.shopStore.provinceId = location.province;
            this.getCity3 = true
            this.getArea3 = true
            this.street3 = true
            this.shopStore.cityId = location.city;
            this.shopStore.areaId = location.area;
            this.shopStore.streetId = location.street;
            this.shopStore.longitude = location.lng;
            this.shopStore.latitude = location.lat;
            console.log(this.shopStore)
        },
        // 大图预览
        updateSrcList(src) {
            this.srcList[0] = src;
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopStoreList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopStoreList = [];
        },
        resetDialog() {
            this.shopStoreState = 'add';
            this.showDialog = false;
            this.queryForm = {
                id: '', //ID
                storeName: '', //门店名称
                storeLogo: '', //门店图片
                provinceId: '', //省
                cityId: '', //市
                areaId: '', //区
                storeAddress: '', //详细地址
                storePosition: '', //定位
                longitude: '', //经度
                latitude: '', //纬度
                openStatus: '', //营业状态
                openHours: '', //营业时间
                contactPerson: '', //联系人姓名
                contactPhone: '', //联系人电话
                remarks: '', //备注
                userId: '', //店铺管理
                createTime: '' //创建时间
            };
            this.getShopStoreList();
        },
        resetDialogEdit() {
            this.shopStoreState = 'add';
            this.showDialog = false;
            this.getShopStoreList();
        },
        closeDialog() {
            this.showDialog = false;
            this.shopStore = {
                id: '', //ID
                storeName: '', //门店名称
                storeLogo: '', //门店图片
                provinceId: '', //省
                cityId: '', //市
                areaId: '', //区
                storeAddress: '', //详细地址
                storePosition: '', //定位
                longitude: '', //经度
                latitude: '', //纬度
                streetId: "",
                openStatus: '', //营业状态
                openHours: ['08:00', '20:00'], //营业时间
                contactPerson: '', //联系人姓名
                contactPhone: '', //联系人电话
                remarks: '', //备注
                userId: '', //店铺管理
                createTime: '', //创建时间
                promoterId: '',
                personId: '',
                deliverId: '',
                sortingId: '',
                storeTags: '',
                storeBanner: "",
                typeId: '',
                grade: '',
                serviceType: '',
                serviceRatio: '',
                signServiceType: '',
                industryId: '',
                storeInterior1: '',
                storeInterior2: '',
                storeInterior: '',
                status: '',
                isShow: ""
            };
        },
        submitForm() {
            if (this.shopStoreState == 'add') {
                this.$refs.shopStoreForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        this.shopStore.openHours = this.shopStore.openHours.join('-');
                        this.shopStore.storeInterior = this.shopStore.storeInterior1 + "|" + this.shopStore.storeInterior2;
                        post(`/shop/store/add`, { ...this.shopStore }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopStoreList();
                                this.resetDialog();
                            } else {
                                this.shopStore.openHours = this.shopStore.openHours.split('-');
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.shopStoreState == 'edit') {
                this.$refs.shopStoreForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        let params = { ...this.shopStore };
                        delete params.user;
                        delete params.area;
                        delete params.city;
                        delete params.province;
                        delete params.orginfo;
                        delete params.street;
                        params.openHours = params.openHours.join('-');
                        params.storeInterior = params.storeInterior1 + "|" + params.storeInterior2;
                        console.log(params);
                        post(`/shop/store/edit`, params).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                // this.resetShopStoreList();
                                this.resetDialogEdit();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        addShopStore() {
            this.showDialog = true;
            this.shopStoreState = 'add';
        },
        checkShopStore(shopStoreId) {
            console.log(shopStoreId);
            this.currentShopStoreId = shopStoreId;

            this.getShopStoreById();
            this.showDialog = true;
            this.shopStoreState = 'check';
        },
        editShopStore(shopStoreId) {
            if (shopStoreId) {
                this.currentShopStoreId = shopStoreId;
                this.getShopStoreById();
            } else {
                this.shopStore = { ...this.shopStore, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.shopStoreState = 'edit';
        },
        deleteShopStore(shopStoreId) {
            let ids = '';
            if (shopStoreId) {
                ids = shopStoreId;
            } else {
                ids = this.multipleSelection.map((shopStore) => shopStore.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/store/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopStoreList();
                            this.getShopStoreList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshShopStoreList() {
            this.resetShopStoreList();
            this.getShopStoreList();
        },
        getShopStoreList(query = {}) {
            this.loading = true;
            get(`/shop/store/findList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    for (let listElement of res.page.list) {
                        if(listElement.storeInterior){
                            let array = listElement.storeInterior.split('|');
                            listElement.storeInterior1 = array[0];
                            listElement.storeInterior2 = array[1];
                        }
                    }
                    this.shopStoreList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getShopStoreById() {
            get(`/shop/store/get`, { id: this.currentShopStoreId }).then((res) => {
                if (res.success) {
                    this.shopStore = { ...this.shopStore, ...res.shopStore };
                    this.shopStore.openHours = this.shopStore.openHours.split('-');
                    if(this.shopStore.storeInterior){
                        let array = this.shopStore.storeInterior.split('|');
                        this.shopStore.storeInterior1 = array[0];
                        this.shopStore.storeInterior2 = array[1];
                    }
                    this.getCity3 = true
                    this.getArea3 = true
                    this.street3 = true
                    this.getRatio = true
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },

        // 查看进件按钮
        showRegister(item, storeId){
            this.registerVisible = true;
            this.shopStoreOrgInfo.storeId = storeId;
            if(item){
                this.getShopStoreOrgInfoById(item.id);
            }
        },

        // 关闭进件按钮
        closeRegister(){
            this.registerVisible = false;
            this.shopStoreOrgInfo = {
                    userId: '', //用户id
                    storeId: '', //门店id
                    storeIndustry: '', //商户行业
                    subAccount: '', //子商户号
                    orgType: '', //组织类型 1小微 2企业 3个体
                    licensePic: '', //营业执照图片
                    licenseProvinceId: '', //营业执照省
                    licenseCityId: '', //营业执照市
                    licenseAreaId: '', //营业执照区
                    licenseTownId: '', //营业执照乡镇
                    licenseName: '', //营业执照名称
                    licenseAddress: '', //营业执照地址
                    licenseNumber: '', //社会统一信用代码
                    licenseIsPermanent: 0,
                    licenseStartTime: '', //营业执照有效开始日期
                    licenseEndTime: '', //营业执照有效结束日期
                    licenseRange: '', //营业执照经营范围
                    personName: '', //真实姓名
                    personMobile: '', //法人手机号
                    idCard: '', //身份证号
                    idCardIsPermanent: 0,
                    idCardStartTime: '', //身份证有效开始日期
                    idCardEndTime: '', //身份证有效结束日期
                    idCardFacade: '', //身份证正面图片
                    idCardBack: '', //身份证背面图片
                    idCardAddress: '', //身份证地址
                    bankAccount: '', //银行账号
                    bankHolder: '', //银行卡持有人
                    bankMobile: '', //银行预留手机号
                    bankCardFacade: '', //银行卡正面图片
                    bankCardBack: '', //银行卡背面图片
                    bankAccountVoucher: '', //对公账户凭证
                    bankName: '', //银行名称
                    bankSubbranch: '', //开户支行名称
                    bankProvinceId: '', //开户行省
                    bankCityId: '', //开户行市
                    bankAreaId: '', //开户行市
                    bankTownId: '', //开户行乡镇
                    thirdStatus: '', //支付审核状态
                    alipayStatus: '', //支付宝支付审核状态
                    wxpayStatus: '', //微信支付审核状态
                    resultMsg: '', //响应报文
                    signPic: '', //签名图片
                    contractUrl: '', //合同地址
                    otherInfor: '', //其他补充资料 如烟草经营许可证
            }
        },

        // 修改进件信息
        submitRegister(){
            if(this.shopStoreOrgInfo.id){

                delete this.shopStoreOrgInfo.licenseProvince
                delete this.shopStoreOrgInfo.licenseCity
                delete this.shopStoreOrgInfo.licenseArea
                delete this.shopStoreOrgInfo.licenseTown
                delete this.shopStoreOrgInfo.bankProvince
                delete this.shopStoreOrgInfo.bankCity
                delete this.shopStoreOrgInfo.bankArea
                delete this.shopStoreOrgInfo.bankTown
                delete this.shopStoreOrgInfo.store
                delete this.shopStoreOrgInfo.user

                this.$refs.shopStoreOrgInfoForm.validate((valid) => {
                    if (valid) {
                        post(`/shop/storeorginfo/edit`,{ ...this.shopStoreOrgInfo }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.closeRegister()
                                this.pageSize = 10;
                                this.currentPage = 1;
                                this.shopStoreList = [];
                                this.getShopStoreList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else {
                this.$refs.shopStoreOrgInfoForm.validate((valid) => {
                    if (valid) {
                        post(`/shop/storeorginfo/add`,{ ...this.shopStoreOrgInfo }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000,
                                });
                                this.closeRegister()
                                this.pageSize = 10;
                                this.currentPage = 1;
                                this.shopStoreList = [];
                                this.getShopStoreList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },

        // 获取进件信息
        getShopStoreOrgInfoById(id) {
            get(`/shop/storeorginfo/get`,{ id }).then((res) =>{
                if(res.success){
                    this.shopStoreOrgInfo = { ...this.shopStoreOrgInfo, ...res.shopStoreOrginfo };
                    this.getCity = true;
                    this.getArea = true;
                    this.street = true;
                    this.getCity2 = true;
                    this.getArea2 = true;
                    this.street2 = true;

                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },

        /**
         * 导出信息
         */
        exportShopStoreList() {
            //this.btnLoading = true;
            exprotExcel(`/shop/store/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/shop/store/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/shop/store/importData`, formData);
            this.refreshShopStoreList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopStoreList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopStoreList();
        },
        currentChanges(page) {
            this.currentPages = page;
            this.openList(this.cid);
        },
        sizeChanges(size) {
            this.pageSizes = size;
            this.openList(this.cid);
        }
    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    button {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.avatar {
    width: 130px;
    height: 130px;
    display: block;
}

::v-deep .el-upload--text {
    width: 130px;
    height: 130px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

::v-deep .el-range-separator {
    width: 20px;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 130px;
    height: 130px;
    line-height: 130px;
    text-align: center;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}

.flex{
    display: flex;
    align-items: center;
    justify-content: center;
}
.active{
    color:#67C23A;
}
</style>